export function doLogout(href = "/") {
  localStorage.removeItem("token");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("member-storage");
  window.location.href = href;
}
